<template>
  <v-row>
    <v-col>
      <v-card flat class="bordered" v-if="ligneCopy">
        <v-card-text>
          <v-expansion-panels v-model="pan" accordion multiple flat>
            <v-expansion-panel
              v-for="(item, i) in lines()"
              :key="'match-' + i"
              class="color_thead lighten-1 mb-1"
            >
              <show-command-header :match="item" />
              <v-expansion-panel-content class="bordered">
                <v-container fluid class="bordered">
                  <show-command-detail :commande="item.commande" />
                  <v-form>
                    <v-container fluid>
                      <v-row>
                        <v-text-field
                          v-model="item.compteComptable"
                          :disabled="disabled"
                          color="indigo"
                          background-color="white"
                          dense
                          @input="formatNumber"
                          outlined
                          :label="$t('commande.compteComptable')"
                        />
                        <v-spacer />
                        <v-checkbox
                          v-model="item.isAbonnement"
                          dense
                          :disabled="disabled"
                          class="ml-1"
                          outlined
                          :label="$t('commande.isAbonnement')"
                        />
                        <v-spacer />
                        <v-text-field
                          v-if="item.isAbonnement"
                          v-model="item.montant_abonnement"
                          background-color="white"
                          color="indigo"
                          :disabled="disabled"
                          dense
                          outlined
                          :label="$t('commande.montant.abonnement')"
                          @input="
                            item.montant_abonnement = parseFloat(
                              replaceVirguleFloat(item.montant_abonnement)
                            );
                            item.montant_ht = item.montant_abonnement;
                            item.tva = 0;
                            item.montant_tva = 0;
                            item.montant_ttc = item.montant_abonnement;
                            item.montant_utilise_init = item.montant_abonnement;
                          "
                        />
                      </v-row>
                    </v-container>
                  </v-form>
                  <v-row>
                    <v-col>
                      <table width="100%" class="white pa-3 indigo--text">
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t("commande.montant.restant") }}
                            </th>
                            <th class="text-left">
                              {{ $t("commande.montant.hTRapprochement") }}
                            </th>
                            <th class="text-left">
                              {{ $t("commande.tva") }}
                            </th>
                            <th class="text-left">
                              {{ $t("commande.code_tva") }}
                            </th>
                            <th class="text-left">
                              {{ $t("commande.montant.tvaModifiable") }}
                            </th>
                            <th class="text-right">
                              {{ $t("commande.montant.ttcRapprochement") }}
                            </th>
                            <th class="text-right">
                              {{ $t("rob.lignesRob.montant") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td :class="cantAdd(item) ? 'red--text' : ''">
                              {{ nbMonnaie(item.commande.montant_restant) }}
                            </td>
                            <td>
                              <v-text-field
                                v-model="item.montant_ht"
                                :disabled="disabled"
                                :rules="[validrules.float()]"
                                single-line
                                @input="
                                  item.montant_ht = parseFloat(
                                    replaceVirguleFloat(item.montant_ht)
                                  );
                                  item.montant_tva = arrondi2(
                                    item.montant_ht * (item.tva / 100)
                                  );
                                  item.montant_ttc =
                                    item.montant_ht + item.montant_tva;
                                "
                              />
                            </td>
                            <td>
                              <v-select
                                v-model="item.tva"
                                :disabled="disabled"
                                :items="TVA"
                                single-line
                                @change="
                                  item.montant_tva = arrondi2(
                                    item.montant_ht * (item.tva / 100)
                                  );
                                  item.montant_ttc =
                                    item.montant_ht + item.montant_tva;
                                "
                              />
                            </td>
                            <td>
                              <v-select
                                v-model="item.tax_rate_id"
                                :disabled="disabled"
                                :items="filteredTvas(item)"
                                item-text="tax_rate_code"
                                item-value="tax_rate_id"
                                single-line
                              />
                            </td>
                            <td>
                              <v-text-field
                                v-model="item.montant_tva"
                                :disabled="disabled"
                                :rules="[validrules.float()]"
                                single-line
                                @input="
                                  item.montant_tva = parseFloat(
                                    replaceVirguleFloat(item.montant_tva)
                                  );
                                  item.montant_ttc =
                                    item.montant_ht + item.montant_tva;
                                "
                              />
                            </td>
                            <td class="text-right">
                              <span :class="cantAdd(item) ? 'red--text' : ''">
                              </span>
                              {{ nbMonnaie(item.montant_ttc) }}
                            </td>
                            <td class="text-right">
                              <span
                                :class="
                                  montantLigne === item.montant_ttc
                                    ? 'green--text'
                                    : 'red--text'
                                "
                              >
                                {{ nbMonnaie(montantLigne()) }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      item.commande.ligne_liees &&
                      item.commande.ligne_liees.length > 0
                    "
                  >
                    <v-col>
                      <v-alert type="info">
                        <strong>Déjà liées avec :</strong>
                        <ul>
                          <li
                            v-for="(val, ind) in item.commande.ligne_liees"
                            :key="ind"
                          >
                            {{ val }}
                          </li>
                        </ul>
                      </v-alert>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-spacer />
                    <v-btn
                      v-if="type === 'linking'"
                      :disabled="!user.is_dr"
                      color="color_action"
                      @click="remove(item)"
                    >
                      <v-icon left dark> mdi-minus</v-icon>
                      {{ $t("btn.edit") }}
                    </v-btn>
                    <v-btn
                      v-else
                      :disabled="!user.is_dr || cantAdd(item)"
                      color="color_action"
                      @click="add(item)"
                    >
                      <v-icon left dark> mdi-plus</v-icon>
                      {{ $t("btn.add") }}
                    </v-btn>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import showCommandDetail from "@/components/ShowCommandDetail";
import showCommandHeader from "@/components/ShowCommandHeader";
import { libUtilMixin } from "@/mixins/libUtilMixin";
import { ligneRobMixin } from "@/mixins/ligneRob";
import { montantLigne, replaceVirguleFloat } from "@/common/lib";
import { userMixin } from "@/mixins/user";
import { validrules } from "@/common/validrules";
import { TVA } from "@/common/variables";
import { linkRobMixin } from "@/mixins/link";
import { tvaMixin } from "@/mixins/tva";

export default {
  name: "VueShowCommandeLiees",
  components: {
    showCommandDetail,
    showCommandHeader,
  },
  mixins: [ligneRobMixin, userMixin, libUtilMixin, linkRobMixin, tvaMixin],
  data() {
    return {
      pan: [],
      ligneCopy: null,
      validrules: validrules,
      replaceVirguleFloat: replaceVirguleFloat,
      TVA: TVA,
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: "",
    },
    aleat: {
      type: Number,
      default: null,
    },
  },
  computed: {
    disabled() {
      return this.type === "linking" ? true : !this.user.is_dr;
    },
  },
  methods: {
    formatNumber(number) {
      number = number.toString();
      this.item.compteComptable = number.endsWith(".0")
        ? number.slice(0, -2)
        : number;
    },
    filteredTvas(item) {
      return item.tva !== null
        ? this.tvas.filter((x) => x.value === item.tva)
        : null;
    },
    montantLigne() {
      return montantLigne(this.ligneCopy);
    },
    lines() {
      return this.type === "linking"
        ? this.ligneCopy.linkRobCommandes
        : this.ligneCopy.matchingsCommands !== null
        ? this.ligneCopy.matchingsCommands
        : null;
    },
    cantAdd(item) {
      return (
        item.tva === undefined ||
        item.tva === null ||
        item.montant_tva === undefined ||
        item.montant_tva === null ||
        item.montant_ht === undefined ||
        item.montant_ht === null ||
        item.montant_ttc === undefined ||
        item.montant_ttc === null ||
        item.tax_rate_id === undefined ||
        item.tax_rate_id === null ||
        Math.round((item.commande.montant_restant * 100) / 100) <
          Math.round((item.montant_ht * 100) / 100) ||
        Math.round(((item.montant_ht + item.montant_tva) * 100) / 100) >
          Math.round((this.montantLigne() * 100) / 100) ||
        item.montant_ht < 0
      );
    },
    add(item) {
      item.commande.montant_utilise += item.montant_ht;
      item.commande.montant_restant =
        item.commande.montant - item.commande.montant_utilise;
      this.ligneCopy.linkRobCommandes.push(item);
      this.ligneCopy.statut = this.montantLigne() <= 0;
      this.createLink({
        values: {
          ligne_rob: this.ligneCopy.id,
          commande: item.commande.id,
          montant_ht: item.montant_ht,
          montant_ttc: item.montant_ttc,
          montant_tva: item.montant_tva,
          compteComptable: item.compteComptable,
          montant_abonnement: item.is_abonnement
            ? item.commande.montant_abonnement
            : 0,
          tva: item.tva,
          statut: this.ligneCopy.statut,
          tax_rate_id: item.tax_rate_id,
        },
        item: item,
      });
      this.$emit("input", this.ligneCopy);
      this.pan = [];
      this.$emit("openPan", { canModify: this.pan.length === 0 });
    },
    remove(item) {
      const index = this.ligneCopy.linkRobCommandes.findIndex(
        (x) => x.commande.id === item.commande.id
      );
      this.ligneCopy.linkRobCommandes.splice(index, 1);
      this.ligneCopy.statut = this.montantLigne() <= 0;
      item.commande.montant_utilise -= item.montant_ht;
      item.commande.montant_restant =
        item.commande.montant - item.commande.montant_utilise;
      this.deleteLink(item.id);
      this.$emit("input", this.ligneCopy);
      this.pan = [];
      this.$emit("openPan", { canModify: this.pan.length === 0 });
    },
  },
  watch: {
    aleat() {
      this.pan = [];
      this.ligneCopy.matchingsCommands.forEach(function (line) {
        line.tax_rate_id = null;
      });
      this.ligneCopy = { ...this.value };
    },
    pan() {
      this.$emit("openPan", { canModify: this.pan.length === 0 });
    },
  },
  mounted() {
    this.ligneCopy = { ...this.value };
  },
};
</script>

<style scoped></style>
